var constants = require('./constants');

const STATSIG_GOALS = {
    CART: { name: 'ecomm_cart', value: null },
    INTENT_PROCEED: { name: 'ecomm_step_continue_cta', value: 'cart' },
    CHECKOUT_LOGIN: { name: 'account_registration_login', value: null },
    CHECKOUT_DELIVERY: { name: 'ecomm_checkout', value: null },
    CHECKOUT_PAYMENT: { name: 'ecomm_payment', value: null },
    CHECKOUT_CONFIRMATION: { name: 'ecomm_completed', value: null },
    SIGNUP: { name: 'sign_up', value: null }
};

function logStatsigEvent(id) {
    if (!window.Statsig) {
        return;
    }

    if (!STATSIG_GOALS[id]) {
        return;
    }

    const event = STATSIG_GOALS[id];

    window.Statsig.StatsigClient.instance().logEvent(event.name, event.value);
}

function toggleCheckoutOfferBanner() {
    if (window.Statsig) {
        const $body = $('body');
        const $checkoutOfferBanner = $body.find('.js-checkout-offer-banner');
        const statsigInstance = window.Statsig.StatsigClient.instance();
        const experiment = statsigInstance.getExperiment('offer_banner');
        const isOfferBannerEnabled = experiment.get('isOfferBannerEnabled');

        if (isOfferBannerEnabled) {
            $checkoutOfferBanner.removeClass('d-none');
        }
    }
}

function requestACallback() {
    if (window.Statsig) {
        const statsigInstance = window.Statsig.StatsigClient.instance();

        const $stickyBanner = $('.header-banner.calendly');
        const $footer = $('footer.site-footer')[0];

        if ($stickyBanner.length > 0) {
            const stickyBannerExperiment = statsigInstance.getExperiment('request_a_callback_sticky_banner');
            const showStickyBanner = stickyBannerExperiment.get('show_modal');

            if (showStickyBanner) {
                $stickyBanner.removeClass('d-none');
            }
        }

        if ($footer) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const footerExperiment = statsigInstance.getExperiment('request_a_callback_footer_link');
                        const showFooterLink = footerExperiment.get('show_modal');
                        if (showFooterLink) {
                            $('footer .calendly-link').removeClass('d-none');
                        }

                        observer.unobserve($footer);
                    }
                });
            }, { threshold: 0.1 });

            observer.observe($footer);
        }
    }
}

module.exports = {
    handleEvent: function (event) {
        const stepGoalMap = {
            cart: 'CART',
            intentToProceed: 'DUALMODE_INTENT_PROCEED',
            signup: 'SIGNUP',
            0: 'CHECKOUT_LOGIN',
            1: 'CHECKOUT_DELIVERY',
            2: 'CHECKOUT_PAYMENT',
            4: 'CHECKOUT_CONFIRMATION',
        };

        const goal = stepGoalMap[event];
        if (goal) {
            logStatsigEvent(goal);
        }
    },
    updateStatsigUser: function (data) {
        // Update the user object
        if (window.Statsig && data && data.statsigUserID) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const { user } = statsigInstance.getContext();
            const newUser = { ...user, userID: data.statsigUserID }
            statsigInstance.updateUserSync(newUser);

            const date = new Date();
            date.setTime(date.getTime() + constants.DAYS_30); // 1 month
            document.cookie = 'statsig_user=' + JSON.stringify(newUser) + '; path=/; ' + cookieDomain + 'expires=' + date.toUTCString() + '; Secure; SameSite=None;';
        }
    },
    handleExperiments: function () {
        toggleCheckoutOfferBanner();
        requestACallback();
    },
    showFeedingGuidelinesTable: function () {
        if (window.Statsig) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const experiment = statsigInstance.getExperiment('pdp_feeding_guideline');
            const isGuidelinesDropdownVisible = experiment.get('guidelinesDropdownVisible');
            if (isGuidelinesDropdownVisible) {
                $('.pdp-feeding-guidelines-table').removeClass('d-none');
            }
        }
    },
    shouldPrepopulateGuestCheckoutEmail: function () {
        if (window.Statsig) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const experiment = statsigInstance.getExperiment('guest_checkout__wizard_customer_email_prepopulated');
            return experiment.get('prepopulateEmail') === true;
        }
        return false;
    }
};
